import { Injectable } from "@angular/core";
import {
  RealtimeSubscriptionHandle,
  RealtimeSubscriptionRequest,
  RealtimeSubscriptionService,
} from "../realtime-subscription.service";
import {
  NotificationWebSocketMessage,
  USER_DEVICE_REGISTRATION_REQUIRED_CLOSE_CODE,
} from "../../../models/ws/realtimeNotification";

export interface NotificationSubscriptionDescriptor extends RealtimeSubscriptionRequest {
  deviceId: string;
}

export type NotificationSubscriptionHandle = RealtimeSubscriptionHandle<
  NotificationWebSocketMessage,
  NotificationSubscriptionDescriptor
>;

@Injectable({
  providedIn: "root",
})
export class NotificationsWebsocketService extends RealtimeSubscriptionService<
  NotificationWebSocketMessage,
  NotificationSubscriptionDescriptor
> {
  protected readonly PATH = "notifications";
  protected readonly VERSION = 1;
  protected override readonly TERMINAL_ERROR_CLOSE_CODES = [USER_DEVICE_REGISTRATION_REQUIRED_CLOSE_CODE];
}
